import React, { memo } from 'react';
import { ENV_CONFIG } from '../../../../constants/envConfig';
import { useIntl } from 'react-intl';
import QuestionMarkCircle from '../../../../../main/resources/images/question-mark-circle28.svg';
import GlobalModal from '../../atoms/globalModal/GlobalModal';
import Button from '../../atoms/button';
import './header.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../utils/commonUtils';

const HelpModal = ({ helpModal, closeHelpModal }) => {
    const {
        HELP_SUPPORT_MODAL_PRIMARY_BUTTON_LABEL: helpModalPrimaryLabel,
        HELP_SUPPORT_MODAL_SECONDARY_BUTTON_LABEL: helpModalSecondaryLabel,
        HELP_SUPPORT_MODAL_SECONDARY_BUTTON_PHONE_NUMBER_LABEL: helpModalPhoneNumberLabel,
        HELP_SUPPORT_MODAL_TITLE: helpModalTitle,
        HELP_SUPPORT_MODAL_TEXT: helpModalText
    } = ENV_CONFIG || {};
    const intl = useIntl();
    const phoneNumber = convertPhoneNumberAsPerSbmChannel(helpModalPhoneNumberLabel);

    const launchLiveChatBox = () => {
        LiveChatWidget.call('maximize');
        closeHelpModal();
    };

    const helpTitle = () => {
        return (
            <>
                {helpModalTitle && (
                    <>
                        <QuestionMarkCircle className="exitmodal__title-icon" tabIndex={'-1'} aria-hidden={true} />
                        <span className="helpmodal__title">{helpModalTitle}</span>
                    </>
                )}
            </>
        );
    };

    const helpContent = () => {
        return (
            <>
                <div className="helpmodal__content" tabIndex={'0'}>
                    {helpModalText && <p>{helpModalText}</p>}
                </div>
                <div className="helpmodal__actions">
                    {helpModalPrimaryLabel && (
                        <Button
                            tabIndex={0}
                            buttonAriaLabel={helpModalPrimaryLabel}
                            className={`button button-primary button-block`}
                            onClick={launchLiveChatBox}>
                            {helpModalPrimaryLabel}
                        </Button>
                    )}
                    {helpModalSecondaryLabel && (
                        <a
                            href={`tel:${phoneNumber}`}
                            aria-label={`${intl.formatMessage({ id: 'account:ac-common-click-here-msg' })} ${helpModalSecondaryLabel + ' ' + phoneNumber}`}
                            className={'button button-outline-primary button-block '}>
                            {helpModalSecondaryLabel + ' ' + phoneNumber}
                        </a>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                className={'width-327'}
                isOpen={helpModal}
                onRequestClose={closeHelpModal}
                title={helpTitle()}
                portalClassName={'cca-help-modal'}
                content={helpContent()}
                handleClose={closeHelpModal}
            />
        </>
    );
};

export default memo(HelpModal);
